var SplitTicketType = /* @__PURE__ */ ((SplitTicketType2) => {
  SplitTicketType2["THROUGH"] = "Through";
  SplitTicketType2["INTERCHANGE_SPLIT"] = "InterchangeSplit";
  SplitTicketType2["DIRECT_SPLIT"] = "DirectSplit";
  return SplitTicketType2;
})(SplitTicketType || {});
var SplitTicketType_default = SplitTicketType;
export {
  SplitTicketType_default as default
};
